var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.key},[(_vm.show_ai)?_c('div',[_c('div',{staticClass:"ai-menu"},[_c('ai-folder-vue')],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }